import {
  defaultSystemCodeArea,
  exists,
  SystemCodeArea,
  SystemCodeAreaFromJSON
} from '@/api'

export interface SystemCodeAddress {
  id: number
  code: string
  areaCode: SystemCodeArea
  zipCode: string
  name: string
  revision: number
}

export function SystemCodeAddressFromJSON(json: any): SystemCodeAddress {
  return {
    id: exists(json, 'id') ? json.id : 0,
    code: exists(json, 'code') ? json.code : '',
    areaCode: exists(json, 'area_code')
      ? SystemCodeAreaFromJSON(json.area_code)
      : defaultSystemCodeArea(),
    zipCode: exists(json, 'zip_code') ? json.zip_code : '',
    name: exists(json, 'name') ? json.name : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}

export const defaultSystemCodeAddress = (): SystemCodeAddress => ({
  id: 0,
  code: '',
  areaCode: defaultSystemCodeArea(),
  zipCode: '',
  name: '',
  revision: 1
})
